import { UsuarioService } from './../../services/usuario.service';
import { UtilitarioService } from '../../services/utilitario.service';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

// Roteamento
import { ProcessosRoutingModule } from './processos.routing';

// Guardas
// import { AuthGuard } from '@app/guards/auth.guard';

// Módulos
import { SharedModule } from '@app/shared/shared.module';
import { ToastrModule } from 'ngx-toastr';

// Componentes
import { BuscarProcessosComponent } from '@app/pages/processos/buscar-processos/buscar-processos.component';
import { ProcessoAdministrativoFormComponent } from '@app/pages/processos/processo-administrativo-form/processo-administrativo-form.component';
import { ProcessoJudicialFormComponent } from '@app/pages/processos/processo-judicial-form/processo-judicial-form.component';
import { ProcessoComponent } from '@app/pages/processos/processo/processo.component';
import { ResumoComponent } from '@app/pages/processos/processo/resumo/resumo.component';
import { DadosDoProcessoComponent } from '@app/pages/processos/processo/shared/dados-do-processo/dados-do-processo.component';
import { EntrevistaComponent } from '@app/pages/processos/processo/entrevista/entrevista.component';
import { ObservacaoComponent } from '@app/pages/processos/processo/observacao/observacao.component';
import { AudienciaListaComponent } from '@app/pages/processos/processo/audiencia/audiencia-lista/audiencia-lista.component';
import { AudienciaFormComponent } from '@app/pages/processos/processo/audiencia/audiencia-form/audiencia-form.component';
import { AnexosComponent } from '@app/pages/processos/processo/anexos/anexos.component';
import { ArquivosComponent } from '@app/pages/processos/processo/arquivos/arquivos.component';
import { DocumentosFormComponent } from '@app/pages/processos/processo/documentos/documentos-form/documentos-form.component';
import { DocumentosListaComponent } from '@app/pages/processos/processo/documentos/documentos-lista/documentos-lista.component';
import { GerarDocComponent } from '@app/pages/processos/processo/gerardoc/gerardoc.component';
import { GerarDocFormComponent } from '@app/pages/processos/processo/gerardoc/gerardoc-form/gerardoc-form.component';
import { AtendimentoComponent } from '@app/pages/processos/processo/atendimento/atendimento.component';
import { SolicitarDocumentosComponent } from '@app/pages/processos/processo/solicitar-documentos/solicitar-documentos.component';
import { PeticaoOnlineComponent } from '@app/pages/processos/processo/peticao-online/peticao-online.component';
import { GerenciarPrazosComponent } from '@app/pages/processos/gerenciar-prazos/gerenciar-prazos.component';
import { GerenciarMovAdministrativaComponent } from '@app/pages/processos/gerenciar-mov-administrativa/gerenciar-mov-administrativa.component';
import { MovimentacaoListaComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-lista/movimentacao-lista.component';
import { MovimentacaoFormComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/movimentacao-form.component';
import { MovimentacaoAnexoFormComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/movimentacao-anexo-form.component';
import { MovimentacaoMeAviseFormComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/movimentacao-meavise-form.component';
import { MovimentacaoPrazoFormComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/movimentacao-prazo-form.component';
import { MovMeAviseComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/mov-me-avise/mov-me-avise.component';
import { MovAudienciaComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/mov-audiencia/mov-audiencia.component';
import { MovMeAvisePrazoComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/mov-me-avise-prazo/mov-me-avise-prazo.component';
import { MovimentacaoHistoricoComponent } from '@app/pages/processos/processo/movimentacao/movimentacao-form/movimentacao-historico/movimentacao-historico.component';
import { SolicitacoesPastasComponent } from '@app/pages/processos/solicitacoes-pastas/solicitacoes-pastas.component';
import { ImportacaoPublicacaoComponent } from '@app/pages/processos/importacao-publicacao/importacao-publicacao.component';
import { EncaminharPastaComponent } from '@app/pages/processos/solicitacoes-pastas/encaminhar-pasta/encaminhar-pasta.component';
import { ModalPrazosComponent } from '@app/pages/processos/processo/shared/modal-prazos/modal-prazos';
import { MovimentacaoComponent } from '@app/pages/processos/processo/movimentacao/movimentacao.component';
//import { MeAviseComponent } from '@app/pages/processos/processo/movimentacao/me-avise/me-avise.component';
import { MeAvisePrazoComponent } from '@app/pages/processos/processo/shared/me-avise-prazo/me-avise-prazo.component';
import { ObservacaoMovimentacaoProcessoComponent } from '@app/pages/processos/processo/shared/movimentacao-observacoes/movimentacao-observacoes.component';
import { TabelaProcessosComponent } from './buscar-processos/tabela-processos/tabela-processos.component';

import { UploadFileComponent } from '@app/components/upload-file/upload-file.component';
import { ClipboardModule } from 'ngx-clipboard';

// Services
import { ConsultasService } from './../../services/consultas.service';
import { FuncionarioService } from '@app/services/funcionario.service';
import { EntrevistaService } from '@app/services/entrevista.service';
import { ImportacaoPublicacaoService } from '@app/services/importar-publicacao.service';
import { PrazoService } from '@app/services/prazo.service';
import { ProcessoArquivoService } from '@app/services/processo-arquivo.service';
import { ProcessoService } from '@app/services/processo.service';
import { ProcessoMovimentacaoService } from '@app/services/processo-movimentacao.service';
import { ProcessoGerarDocService } from '@app/services/processo-gerardoc.service';
import { ProcessoDocumentoService } from '@app/services/processo-documento.service';
import { PlanoControleService } from '@app/services/plano-controle.service';
import { TextMaskModule } from 'angular2-text-mask';
import { FinanceiroProcessoRelatorioComponent } from '../financeiro/financeiro-processo/financeiro-processo-relatorio/financeiro-processo-relatorio.component';
import { TutelaProvisoriaFormComponent } from '../financeiro/financeiro-processo/tutela-provisoria-form/tutela-provisoria-form.component';
import { FinanceiroProcessoFormComponent } from '../financeiro/financeiro-processo/financeiro-processo-form/financeiro-processo-form.component';
import { FinanceiroProcessoComponent } from '../financeiro/financeiro-processo/financeiro-processo/financeiro-processo.component';
import { FinanceiroProcessoTitulosComponent } from '../financeiro/financeiro-processo/financeiro-processo-titulos/financeiro-processo-titulos.component';
import { RelPrestacaoContasComponent } from '../financeiro/financeiro-processo/relatorio-prestacao-contas/relatorio-prestacao-contas.component';
import { PrecatorioComponent } from '../financeiro/financeiro-processo/precatorio/precatorio.component';
import { RpvComponent } from '../financeiro/financeiro-processo/rpv/rpv.component';

@NgModule({
  declarations: [
    BuscarProcessosComponent,
    ProcessoAdministrativoFormComponent,
    ProcessoJudicialFormComponent,
    ProcessoComponent,
    ResumoComponent,
    DadosDoProcessoComponent,
    EntrevistaComponent,
    ObservacaoComponent,
    AudienciaListaComponent,
    AudienciaFormComponent,
    AnexosComponent,
    ArquivosComponent,
    DocumentosFormComponent,
    DocumentosListaComponent,
    GerarDocComponent,
    GerarDocFormComponent,
    AtendimentoComponent,
    SolicitarDocumentosComponent,
    PeticaoOnlineComponent,
    GerenciarPrazosComponent,
    GerenciarMovAdministrativaComponent,
    MovimentacaoListaComponent,
    MovimentacaoFormComponent,
    MovimentacaoAnexoFormComponent,
    MovimentacaoMeAviseFormComponent,
    MovimentacaoPrazoFormComponent,
    MovMeAviseComponent,
    MovAudienciaComponent,
    MovMeAvisePrazoComponent,
    MovimentacaoHistoricoComponent,
    SolicitacoesPastasComponent,
    ImportacaoPublicacaoComponent,
    EncaminharPastaComponent,
    UploadFileComponent,
    ModalPrazosComponent,
    MovimentacaoComponent,
    //MeAviseComponent,
    MeAvisePrazoComponent,
    ObservacaoMovimentacaoProcessoComponent,
    TabelaProcessosComponent,
    FinanceiroProcessoTitulosComponent,
    FinanceiroProcessoComponent,
    FinanceiroProcessoFormComponent,
    TutelaProvisoriaFormComponent,
    FinanceiroProcessoRelatorioComponent,
    RelPrestacaoContasComponent,
    RpvComponent,
    PrecatorioComponent
  ],
  imports: [
    ClipboardModule,
    TextMaskModule,
    ProcessosRoutingModule,
    SharedModule,
    ToastrModule.forRoot({
      timeOut: 7000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
  providers: [
    // AuthGuard,
    ConsultasService,
    FuncionarioService,
    UtilitarioService,
    UsuarioService,
    EntrevistaService,
    ImportacaoPublicacaoService,
    PrazoService,
    ProcessoArquivoService,
    ProcessoDocumentoService,
    ProcessoGerarDocService,
    ProcessoMovimentacaoService,
    ProcessoService,
    PlanoControleService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ProcessosModule { }
